import { prefetchProductImages } from '~/composables/useImagePrefetch'

export default defineNuxtPlugin((nuxtApp) => {
  // wait until the app is mounted
  nuxtApp.hook('app:mounted', () => {
    // schedule in idle time (or fallback to a timeout)
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => prefetchProductImages())
    } else {
      setTimeout(() => prefetchProductImages(), 800)
    }
  })
})
